<template>
    <ModalPlayerLayout :closeModal="this.closeSettingsModal" customClass="body centeredModalBody">
        <template v-slot:default>
            <div class="Accordion">
                <QualitySelection
                    :player="player"
                    :currentQualityIndex="currentQualityIndex"
                />
                <RateSection :player="player" :currentRateIndex="currentRateIndex" />
                <ShortcutSection />
            </div>
        </template>
    </ModalPlayerLayout>
</template>
    
<script>
import ModalPlayerLayout from '../../layout/ModalPlayerLayout/ModalPlayerLayout.vue';
import QualitySelection from './Sections/QualitySelection/QualitySelection.vue';
import RateSection from './Sections/RateSection/RateSection.vue';
import ShortcutSection from './Sections/ShortcutSection/ShortcutSection.vue';
export default {

    name: 'SettingsModal',
    components: {
        ModalPlayerLayout,
        QualitySelection,
        ShortcutSection,
        RateSection
    },
    props: {
        closeSettingsModal: {
            type: Function
        },
        currentQualityIndex: {
            type: Function
        },
        currentRateIndex: {
            type: Function
        },
        player: {
            type: Object
        },
        videoRef: {
            type: Object
        },
    },
    mounted() {
        console.log("options are ", this.player.qualityLevels().levels_.length);
    }
}
</script>
  
<style>
.wrapper {
    width: 100% !important;
}
.Accordion {
    overflow: auto;
    height: 80%;
    top: 0%;
    position: absolute;
    width: inherit;
    padding-right: 6px;
    font-family: Open Sans;
}

.centeredModalBody {
    width: 600px;
    margin: 0px auto;
}
.btnAction {
    color: #fff;
    font-size: 10px;
}
</style>